import { useTranslation } from 'next-i18next'

import SVGImage from '~/components/Image/SVGImage'
import { selectStreakDays } from '~/redux/slices/user'
import { useAppSelector } from '~/redux/hooks'

export default function StreakComponent(): React.ReactElement {
  const { t } = useTranslation(['imageAlt'])
  const dailyStreak = useAppSelector(selectStreakDays)

  return (
    <div className="flex items-center gap-1 h-7.5 md:h-9 pl-2 pr-2.5 rounded-full bg-white-dim border border-solid border-orange-glow-fade">
      <SVGImage
        alt={t('streakFlame')}
        height={20}
        imageClassName="w-4 md:w-5 -rotate-12"
        loading="eager"
        srcKey="icons/on_fire.svg"
        width={20}
      />
      <span className="text-xs md:text-base font-bold text-white">{dailyStreak}</span>
    </div>
  )
}
